import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb', // blue matching logo
    },
    secondary: {
      main: '#f97316', // orange matching logo
    },
    background: {
      default: '#f5f5f5',
      paper: '#fff',
    },
  },
  typography: {
    fontFamily: '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    h1: { fontSize: '2.2rem', fontWeight: 700, fontFamily: '"Geist", sans-serif' },
    h2: { fontSize: '1.8rem', fontWeight: 600, fontFamily: '"Geist", sans-serif' },
    h3: { fontSize: '1.5rem', fontWeight: 500, fontFamily: '"Geist", sans-serif' },
    body1: { fontSize: '1rem', fontFamily: '"Geist", sans-serif' },
    body2: { fontSize: '0.9rem', fontFamily: '"Geist", sans-serif' },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
  },
});

export default theme; 